import React from 'react'

function Threes() {
    return (
        <>
            <div className='bg-white min-h-full'>
                <div>
                    <svg width="100%" height="100%" id="svg" viewBox="0 0 1440 390" xmlns="http://www.w3.org/2000/svg" class="transition duration-300 ease-in-out delay-150"><style>
                    </style><path d="M 0,400 C 0,400 0,200 0,200 C 85.81655788388869,171.611817244933 171.63311576777738,143.22363448986601 241,154 C 310.3668842322226,164.77636551013399 363.2840948127791,214.71727928546892 428,243 C 492.7159051872209,271.2827207145311 569.2305049811063,277.9072483682583 631,240 C 692.7694950188937,202.0927516317417 739.7938852627964,119.65372724149779 798,126 C 856.2061147372036,132.3462727585022 925.5939539677088,227.4778426657506 1000,262 C 1074.4060460322912,296.5221573342494 1153.830298866369,270.43490209549987 1228,250 C 1302.169701133631,229.56509790450016 1371.0848505668155,214.78254895225007 1440,200 C 1440,200 1440,400 1440,400 Z" stroke="none" stroke-width="0" fill="#12071f" fill-opacity="1" class="transition-all duration-300 ease-in-out delay-150 path-0" transform="rotate(-180 720 200)"></path></svg>
                </div>
                <div className="container mx-auto px-4">
                    <div className="flex flex-wrap">
                        <div className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                                <div className="px-4 py-5 flex-auto">
                                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
                                        <i className="fas fa-award"></i>
                                    </div>
                                    <h6 className="text-xl font-semibold">Job Placement</h6>
                                    <p className="mt-2 mb-4 text-gray-600">
                                        We provide full Placement assistance to choose your dream career.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="w-full md:w-4/12 px-4 text-center">
                            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                                <div className="px-4 py-5 flex-auto">
                                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-blue-400">
                                        <i className="fas fa-retweet"></i>
                                    </div>
                                    <h6 className="text-xl font-semibold">
                                        Certified Experience
                                    </h6>
                                    <p className="mt-2 mb-4 text-gray-600">
                                        We prove experience certificate for projects you have done.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="pt-6 w-full md:w-4/12 px-4 text-center">
                            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                                <div className="px-4 py-5 flex-auto">
                                    <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-green-400">
                                        <i className="fas fa-fingerprint"></i>
                                    </div>
                                    <h6 className="text-xl font-semibold">
                                        Trending Courses
                                    </h6>
                                    <p className="mt-2 mb-4 text-gray-600">
                                        We offer you the latest technology courses to stay updated in this competitive world.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <svg width="100%" height="100%" id="svg" viewBox="0 0 1440 390" xmlns="http://www.w3.org/2000/svg" class="transition duration-300 ease-in-out delay-150"><style>
                    </style><path d="M 0,400 C 0,400 0,200 0,200 C 54.16283064239093,168.32703538302988 108.32566128478186,136.65407076605976 184,130 C 259.67433871521814,123.34592923394023 356.86018550326344,141.7107523187908 436,140 C 515.1398144967366,138.2892476812092 576.2335967021642,116.50291995877708 640,138 C 703.7664032978358,159.49708004122292 770.2054276880798,224.277567846101 834,221 C 897.7945723119202,217.722432153899 958.944692545517,146.38680865681897 1032,147 C 1105.055307454483,147.61319134318103 1190.015802129852,220.17519752662315 1260,241 C 1329.984197870148,261.82480247337685 1384.992098935074,230.91240123668842 1440,200 C 1440,200 1440,400 1440,400 Z" stroke="none" stroke-width="0" fill="#12071f" fill-opacity="1" class="transition-all duration-300 ease-in-out delay-150 path-0"></path></svg>
                </div>

                {/* <div>
                    <a href="https://usecheck.com/" class="btn-shine" target="_blank">technoweit</a>
                </div> */}
            </div>
        </>
    )
}

export default Threes